import MusicPlayerImage from './images/MusicPlayerApp.png';
import MasterMindGameImage from './images/MastermindGameApp.png';
import MessagingAppImage from './images/MessagingApp.png';
import NasaAppImage from './images/NasaApp.png';

const workData = [
  {
    title: 'Nasa App (in progress)',
    image: NasaAppImage,
    imageAlt: 'Screenshot of Marie\'s Nasa App',
    techStack: ['React', 'NodeJS', 'Express', 'MongoDB', 'Jest'],
    url: null,
    githubLink: 'https://github.com/Marie20767/nasa-app',
  },
  {
    title: 'Messaging App',
    image: MessagingAppImage,
    imageAlt: 'Screenshot of Marie\'s Messaging App',
    techStack: ['React', 'NodeJS', 'Express', 'PostgreSQL', 'Socket.io'],
    url: 'https://messaging-app.pages.dev',
    githubLink: 'https://github.com/Marie20767/messaging-app',
  },
  {
    title: 'Mastermind Game',
    image: MasterMindGameImage,
    imageAlt: 'Screenshot of Marie\'s Mastermind Game',
    techStack: ['React', 'Typescript', 'Redux', 'Jest', 'Cypress'],
    url: 'https://marie-mastermind.pages.dev/',
    githubLink: 'https://github.com/Marie20767/mastermind-game',
  },
  {
    title: 'Music Player App',
    image: MusicPlayerImage,
    imageAlt: 'Screenshot of Marie\'s Music Player App',
    techStack: ['React', 'SASS', 'Redux'],
    url: 'https://marie-music-player.pages.dev/',
    githubLink: 'https://github.com/Marie20767/music-player-app',
  },
];

export default workData;
